import React from "react";
import { ModalComponent } from "..";
import { SuccessCard } from ".";


const SuccessModal = ({show}) => {
  return (
    <ModalComponent width={600} visible={show}>
      <div className="px-16">
        <SuccessCard />
      </div>
    </ModalComponent>
  );
};

export default SuccessModal;
